import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  modalMsg: { type: "", msg: "" },
  errorCode: "",
  noticeList: {},
  noticeListPending: false,
  noticeListSuccess: false,
  noticeListFailure: false,
  noticeCountPending: false,
  noticeCountSuccess: false,
  noticeCountFailure: false,
  faqList: {},
  faqListPending: false,
  faqListSuccess: false,
  faqListFailure: false,
};
const serviceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    showMsg: (state, payload) => {
      state.modalMsg = {
        msg: payload.payload.msg,
        type: payload.payload.type,
      };
    },

    // **공지사항 리스트 **
    fetchNoticeList: (state) => {
      state.noticeListPending = true;
      state.noticeListSuccess = false;
      state.noticeListFailure = false;
    },
    fetchNoticeListSuccess: (state, { payload }) => {
      state.noticeList = payload.data.params;
      state.noticeListPending = false;
      state.noticeListSuccess = false;
      state.noticeListFailure = false;
    },
    fetchNoticeListFailure: (state, { payload }) => {
      state.noticeListPending = false;
      state.noticeListSuccess = false;
      state.noticeListFailure = true;
    },

    // **공지사항 카운트 **
    fetchNoticeCount: (state) => {
      state.noticeCountPending = true;
      state.noticeCountSuccess = false;
      state.noticeCountFailure = false;
    },
    fetchNoticeCountSuccess: (state, { payload }) => {
      state.noticeCountPending = false;
      state.noticeCountSuccess = false;
      state.noticeCountFailure = false;
    },
    fetchNoticeCountFailure: (state, { payload }) => {
      state.noticeCountPending = false;
      state.noticeCountSuccess = false;
      state.noticeCountFailure = true;
    },

    // **faq 리스트 **
    fetchFaqList: (state) => {
      state.faqListPending = true;
      state.faqListSuccess = false;
      state.faqListFailure = false;
      state.faqList = {};
    },
    fetchFaqListSuccess: (state, { payload }) => {
      state.faqList = payload.data.params;
      state.faqListPending = false;
      state.faqListSuccess = true;
      state.faqListFailure = false;
    },
    fetchFaqListFailure: (state, { payload }) => {
      state.faqListPending = false;
      state.faqListSuccess = false;
      state.faqListFailure = true;
    },
  },
});

// 정의한 액션과 리듀서를 export한다.
export const serviceActions = serviceSlice.actions;
export default serviceSlice;
